module.exports = __webpack_public_path__ + "img/fronius.37057c24.png";